import { ServiceIdentifier } from '../service-locator';
import { TimeService } from './interfaces';

export * from './interfaces';

export const TIME_SERVICE = ServiceIdentifier.get<TimeService>('TimeService');
